var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6701 12.0132L15.6731 12.7214C15.6974 15.5304 15.8668 18.0365 16.1588 19.6247C16.1588 19.6534 16.4773 21.2286 16.6802 21.7529C16.9988 22.5107 17.5748 23.154 18.2969 23.5616C18.8751 23.8524 19.4816 24 20.1165 24C20.6156 23.9769 21.4387 23.7257 22.0262 23.5152L22.5143 23.3281C25.7478 22.0437 31.9288 17.8469 34.296 15.2803L34.4705 15.1009L35.2495 14.2603C35.7404 13.617 36 12.8305 36 11.9846C36 11.2267 35.7687 10.4689 35.3062 9.85643C35.1677 9.65801 34.9447 9.40346 34.7461 9.18837L33.988 8.39478C31.3791 5.75144 25.7303 2.04366 22.8023 0.815128C22.8023 0.788691 20.9827 0.0286396 20.1165 0H20.0009C18.6722 0 17.4308 0.757848 16.7959 1.98274C16.6224 2.31761 16.456 2.97356 16.3295 3.54966L16.1021 4.63741C15.8424 6.38663 15.6701 9.06995 15.6701 12.0132ZM3.00651 8.96332C1.34617 8.96332 0 10.3226 0 11.9991C0 13.6756 1.34617 15.0349 3.00651 15.0349L10.405 14.3806C11.7075 14.3806 12.7635 13.3165 12.7635 11.9991C12.7635 10.6839 11.7075 9.61762 10.405 9.61762L3.00651 8.96332Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/Arrow - Right.3b49ffb6.svg";
export { ForwardRef as ReactComponent };